<script>
  /* Executable code section of the program */
  //Components importation
  import MeetingsCentral from "./MeetingsCentral.svelte";

  //Tools importation
  import { invitedAttendeesArray,userLocalData } from "../apis/storage";
  import {
    getPaginatedDocuments,
    filterFuction,
    getLimitDocuments,
    searchDocumentsByKeyword
  } from "../apis/APIS";
  import { onMount } from "svelte";

  //Auxiliary varibales
  $: dinamicInvitesAttendees = $invitedAttendeesArray;
  let isSelectAll = false;
  let isFilterOn = true;
  export let eventUser;

  //Variables necessary for pagination and filters
  let attendeesArray = [];
  let totalAttendeesArray = [];
  let totalFilterArray = [];
  let reservDocument = [];
  $: dinamicAttendeesData = [];
  let lastDocument = null;
  let isArrayComplete = false;
  let isFilterFuction = false;
  let typedValue = "";
  let category = "";
  let index = 0;
  let totalDocuments = 12;

  //Reset function
  const resetDocuments = async () => {
    dinamicAttendeesData = attendeesArray;
    isFilterFuction = false;
    index = 0;
    isArrayComplete = false;
    typedValue = "";
    lastDocument = reservDocument[0];
    isFilterOn = true;
  };

  //Function to filter data
  const filterAttendees = async (value) => {
    isFilterFuction = true;
    isFilterOn = false
    let categorySelect = document.querySelector(".categorySelect");
    let categoryValue = categorySelect.value;
    category = categorySelect.value;
    let nuevoFiltro = await searchDocumentsByKeyword("users",category,value,eventUser)
    
    /* const { completeCollection, lastDoc } = await filterFuction(
      "users",
      totalDocuments,
      eventUser,
      categoryValue,
      value
    ); */
    
    totalFilterArray.push(nuevoFiltro);
    dinamicAttendeesData = nuevoFiltro;
    index = 0;/* 
    reservDocument.push(lastDoc);
    lastDocument = lastDoc; */
  };

  //Function to get documents and create pagination
  const nextPageData = async () => {
    if (isFilterFuction) {
      //filter pagination fuction
      if (!isArrayComplete) {
        
      typedValue.charAt(0).toUpperCase() + typedValue.slice(1);
        const { completeCollection, lastDoc } = await filterFuction(
          "users",
          totalDocuments,
          eventUser,
          category,
          typedValue,
          lastDocument
        );
        if (completeCollection === undefined) {
          isArrayComplete = true;
        }

        if (completeCollection !== undefined) {
          if (
            !totalFilterArray.some(
              (obj) =>
                JSON.stringify(obj) === JSON.stringify(completeCollection[0])
            ) &&
            !isArrayComplete
          ) {
            totalFilterArray.push(completeCollection);
            dinamicAttendeesData = completeCollection;
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);
            index++;
          }
        }
      } else {
        if (index < totalFilterArray.length - 1) {
          index++;
        }
        dinamicAttendeesData = totalFilterArray[index];
      }
    }

    //normal pagination function
    else {
      if (!isArrayComplete) {
        const { documents, lastDoc } = await getPaginatedDocuments(
          "users",
          eventUser,
          totalDocuments,
          lastDocument
        );
        if (documents.length === 0) {
          isArrayComplete = true;
        }

        if (documents.length > 0) {
          if (
            !totalAttendeesArray.some(
              (obj) => JSON.stringify(obj) === JSON.stringify(documents[0])
            ) &&
            !isArrayComplete
          ) {
            totalAttendeesArray.push(documents);
            dinamicAttendeesData = documents;
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);
            index++;
          }
        }
      } else {
        if (index < totalAttendeesArray.length - 1) {
          index++;
        }
        dinamicAttendeesData = totalAttendeesArray[index];
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prevPageData = async () => {
    if (index >= 1) {
      if (isFilterFuction) {
        //filter pagination fuction
        index--;
        if (!isArrayComplete) {
          lastDocument = reservDocument[index];
        }
        dinamicAttendeesData = totalFilterArray[index];
      } else {
        //normal pagination function
        index--;
        if (!isArrayComplete) {
          lastDocument = reservDocument[index];
        }
        dinamicAttendeesData = totalAttendeesArray[index];
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  //Function to select all attendees
  const selectAll = async () => {
    if (isFilterFuction) {
      let categorySelect = document.querySelector(".categorySelect");
      let categoryValue = categorySelect.value;
      category = categorySelect.value;
      typedValue.charAt(0).toUpperCase() + typedValue.slice(1);
      const { completeCollection, lastDoc } = await filterFuction(
        "users",
        300,
        eventUser,
        categoryValue,
        typedValue
      );
      $invitedAttendeesArray = completeCollection.map(element =>{
        return {
          id:element.id,
          name:element.name,
          surname:element.surname,
          company:element.company,
          country:element.country,
          jobtittle:element.jobtittle,
          profileImgUrl:element.profileImgUrl,

        }
      });
    } else {
      $invitedAttendeesArray = await getLimitDocuments(
        "users",
        "event",
        eventUser,
        300
      );
    }
  };

  onMount(async () => {
    //fetch documents
    if (eventUser !== "") {
      const { documents, lastDoc } = await getPaginatedDocuments(
        "users",
        eventUser,
        totalDocuments,
        lastDocument
      );
      totalAttendeesArray.push(documents);
      attendeesArray = documents;
      attendeesArray = documents.filter(element=>element.id !==$userLocalData[0].id)
      dinamicAttendeesData = attendeesArray;
      lastDocument = lastDoc;
      reservDocument.push(lastDoc);
    }
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<div class="bodyContent">
  <div class="invitedAttendees">
    {#if dinamicInvitesAttendees.length > 0}
      {#if dinamicInvitesAttendees.length < 4}
        {#each dinamicInvitesAttendees as attendee}
          {#if attendee.profileImgUrl !== ""}
            <img src={attendee.profileImgUrl} alt="avatarProfile" />
          {:else}
            <div class="circle">
              {attendee.name.slice(0, 1)}{attendee.surname.slice(0, 1)}
            </div>
          {/if}
        {/each}
      {:else}
        <div class="circle">
          +{$invitedAttendeesArray.length}
        </div>
      {/if}
    {:else}
      <p>No attendees have been authorized</p>
    {/if}
  </div>
  <div class="filterContainer">
    <div class="inputsContainer">
      <div class="form-floating">
        <select
          class="form-select categorySelect"
          name="company"
          id="floatingSelect"
          aria-label="Floating label select example"
        >
          <option selected value="">Select a category</option>
          <option value="name">Name</option>
          <option value="surname">Surname</option>
          <option value="country">Country</option>
          <option value="company">Company</option>
          <option value="jobtittle">Jobtittle</option>
        </select>
        <label for="floatingSelect">Categories</label>
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control formInput"
          placeholder="Tittle Event"
          bind:value={typedValue}
        />
        <label for="floatingPassword">Name attendee</label>
        <br />
      </div>
    </div>
    <div class="btnsContainer">
      <button
        class="actionBtn addEventBtn"
        on:click={() => filterAttendees(typedValue)}>Search</button
      >
      <button class="actionBtn addEventBtn" on:click={resetDocuments}
        >Reset</button
      >
      <button class="actionBtn addEventBtn" on:click={selectAll}
        >Select All</button
      >
      {#if isSelectAll}
        <button class="actionBtn addEventBtn" on:click={selectAll}
          >Select All</button
        >
      {/if}
    </div>
  </div>
  <div class="attendeesList">
    <MeetingsCentral attendeesArray={dinamicAttendeesData} />
  </div>
  {#if isFilterOn}
  <div class="paginationBtns">
    <button class="actionButton addEventBtn" on:click={prevPageData}
      >Previous page</button
    >
    <button class="actionButton addEventBtn" on:click={nextPageData}
      >Next page</button
    >
  </div>
  {/if}
</div>

<!-- End of the section -->
<style>
  /* Section to place the code styles */

  .bodyContent {
    padding: 0 10px;
    width: 100%;
  }

  .invitedAttendees {
    width: 90%;
    border-bottom: 1px solid gray;
    padding: 10px 0;
    display: flex;
  }
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 5px;
  }
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #ed2824;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    margin: 0 5px;
  }

  /* Filter styles */
  .filterContainer {
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 10px 0;
  }
  /* Filters */
  .inputsContainer {
    display: flex;
    margin: 10px 0;
  }
  .form-floating {
    display: flex;
    align-items: flex-end;
    margin: 0 5px;
  }
  .formInput {
    width: 250px;
  }
  /* Buttons */
  .actionButton {
    height: 50px;
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 5px;
  }
  .actionBtn {
    width: 200px;
    height: auto;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 5px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* Attendees list styles */
  .attendeesList {
    background-color: #f4f4f4;
    border-top: 1px solid gray;
    border-bottom: 1px solid gray;
    width: 100%;
    height: 250px;
    overflow: auto;
    /* End section */
  }
  /* Pagination styles */
  .paginationBtns {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Filter styles */
    .filterContainer {
      padding: 0;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 10px 0;
    }
    .form-floating {
      width: 200px;
      display: flex;
      margin: 10px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .invitedAttendees {
      width: 100%;
      padding: 10px;
    }
    /* Filter styles */
    .filterContainer {
      padding: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 0;
    }
    .inputsContainer {
      flex-direction: column;
    }
    .form-floating {
      width: 250px;
      margin: 5px 0;
    }
    .paginationBtns {
      width: 100%;
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .btnsContainer {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .actionBtn {
      margin: 10px;
    }
    .actionButton{
      margin: 5px;
    }

    /* End section */
  }

  /* End of the section */
</style>
